import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { Ciclo, ModalControleValvulasProps } from "./Types";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";

const ModalControleValvulasFechadas: React.FC<ModalControleValvulasProps> = ({
    show,
    onHide,
    ciclo,
}) => {
    const [linha, setLinha] = useState("");
    const [valvula, setValvula] = useState("");
    const [linhasDisponiveis, setLinhasDisponiveis] = useState<string[]>([]);
    const [valvulasDisponiveis, setValvulasDisponiveis] = useState<string[]>([]);
    const user = JSON.parse(localStorage.getItem('user') || '{}');


    const gerarValvulas = (inicio: number, fim: number) => {
        const lista = [];
        for (let i = inicio; i <= fim; i++) {
            lista.push(`V${i}`);
        }
        return lista;
    };

    const REGRAS_AUTOCLAVE: Record<string, Record<string, string[]>> = {
        "Matriz Molde": {
            "L1": gerarValvulas(1, 5),
            "L2": gerarValvulas(6, 10),
            "L3": gerarValvulas(11, 15),
            "L4": gerarValvulas(16, 20),
            "L5": gerarValvulas(21, 25),
        },
        "Ferlex": {
            "L1": gerarValvulas(1, 10),
            "L2": gerarValvulas(11, 20),
            "L3": gerarValvulas(21, 30),
            "L4": gerarValvulas(31, 40),
            "L5": gerarValvulas(1, 10),
            "L6": gerarValvulas(11, 20),
            "L7": gerarValvulas(21, 30),
            "L8": gerarValvulas(31, 40),
        },
        "Fhaizer": {
            "L1": gerarValvulas(1, 10),
            "L2": gerarValvulas(11, 20),
            "L3": gerarValvulas(21, 30),
            "L4": gerarValvulas(31, 40),
            "L5": gerarValvulas(1, 13),
            "L6": gerarValvulas(14, 26),
            "L7": gerarValvulas(27, 39),
        },
        "Chicago": {
            "L1": gerarValvulas(1, 13),
            "L2": gerarValvulas(14, 26),
            "L3": gerarValvulas(27, 39),
            "L4": gerarValvulas(40, 52),
            "L5": gerarValvulas(1, 13),
            "L6": gerarValvulas(14, 26),
            "L7": gerarValvulas(27, 39),
            "L8": gerarValvulas(40, 52),
        }
    };

    const identificarRegra = (nomeAutoclave: string | undefined) => {
        if (!nomeAutoclave) return null;
        const nome = nomeAutoclave.toLowerCase();

        if (nome.includes("matriz") || nome.includes("molde")) return REGRAS_AUTOCLAVE["Matriz Molde"];
        if (nome.includes("ferlex")) return REGRAS_AUTOCLAVE["Ferlex"];
        if (nome.includes("fhaizer") || nome.includes("fha")) return REGRAS_AUTOCLAVE["Fhaizer"];
        if (nome.includes("chicago")) return REGRAS_AUTOCLAVE["Chicago"];


        return REGRAS_AUTOCLAVE["Ferlex"];
    };

    useEffect(() => {
        setLinha("");
        setValvula("");

        if (ciclo?.autoclave) {
            const regra = identificarRegra(ciclo.autoclave);
            if (regra) {
                setLinhasDisponiveis(Object.keys(regra));
            } else {
                setLinhasDisponiveis([]);
            }
        }
    }, [ciclo]);

    useEffect(() => {
        setValvula("");

        if (ciclo?.autoclave && linha) {
            const regra = identificarRegra(ciclo.autoclave);
            if (regra && regra[linha]) {
                setValvulasDisponiveis(regra[linha]);
            } else {
                setValvulasDisponiveis([]);
            }
        }
    }, [linha, ciclo]);


    const clearInputs = () => {
        setLinha("")
        setValvula("")
    }


    const handleEnviarProBack = async (payload: any): Promise<boolean> => {
        try {

            await blogFetch.post("iSAGA_ValvulasFechadas/criar_valvula", payload);


            toast.success("Válvula registrada!");
            return true;
        } catch (err) {
            console.error(err);
            toast.error("Erro ao enviar os dados");
            return false;
        }
    };



    const handleSalvar = async () => {
        if (!linha || !valvula) {
            alert("Preencha a linha e a válvula.");
            return;
        }

        if (!ciclo) {
            alert("Ciclo não selecionado.");
            return;
        }

        const payload = {
            ValvulasFechadas_ciclo: ciclo.ciclo_isaga,
            ValvulasFechadas_autoclave: ciclo.autoclave,
            ValvulasFechadas_linha: linha,
            ValvulasFechadas_valvula: valvula,
            _Create: user.user_UserName
        };

        const sucesso = await handleEnviarProBack(payload);

        if (sucesso) {
            clearInputs();
            onHide();
        }


    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title className="fw-bold">🔒 Controle de Perda de Vacuo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label className="fw-bold">Ciclo</Form.Label>
                                <Form.Control value={ciclo ? ciclo.ciclo_isaga : ""} readOnly disabled className="bg-light" />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label className="fw-bold">Autoclave</Form.Label>
                                <Form.Control value={ciclo ? ciclo.autoclave : ""} readOnly disabled className="bg-light" />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label className="fw-bold">Linha</Form.Label>
                                <Form.Select
                                    value={linha}
                                    onChange={(e) => setLinha(e.target.value)}
                                    disabled={linhasDisponiveis.length === 0}
                                    className="border-2">
                                    <option value="">
                                        {linhasDisponiveis.length === 0 ? "Autoclave sem regra definida" : "Selecione uma linha"}
                                    </option>
                                    {linhasDisponiveis.map((l) => (
                                        <option key={l} value={l}>
                                            {l}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label className="fw-bold">Válvula</Form.Label>
                                <Form.Select
                                    value={valvula}
                                    onChange={(e) => setValvula(e.target.value)}
                                    disabled={!linha}
                                    className="border-2">
                                    <option value="">Selecione uma válvula</option>
                                    {valvulasDisponiveis.map((v) => (
                                        <option key={v} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer className="border-top">
                <Button variant="secondary" className="fw-bold" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" className="fw-bold" onClick={handleSalvar}>
                    ✓ Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalControleValvulasFechadas;
